module.exports = __webpack_public_path__ + "img/calendar-alt.098820e3.svg";